export default __webpack_public_path__ + "static/media/help-logo-bold.66f5c355.svg";